import { Dropdown, Tag, type MenuProps } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useLocationContext } from '../auth/LocationContext';

/**
 * Header location chip — same look as the Arbox Tasks page header:
 *   <Tag bg=white border=white color=#3b3b3b font-size=16 height=38>
 *     <label> <chevron-down>
 *   </Tag>
 *
 * Hidden when the box has only one location (no UI noise for single-branch
 * boxes). Uses antd `Dropdown` for the menu so it's keyboard-accessible and
 * styled consistently with other antd menus.
 */
export function LocationPicker() {
  const { locations, selectedLocationId, setSelectedLocationId, manageLocations } =
    useLocationContext();

  // Hidden when the box has one location, or when it doesn't manage locations
  // (dummy-location boxes treat everything as one bucket).
  if (locations.length <= 1 || !manageLocations) return null;

  const selected = locations.find((l) => String(l.id) === String(selectedLocationId));
  const label = selected?.name ?? 'בחר סניף';

  const items: MenuProps['items'] = locations.map((l) => ({
    key: String(l.id),
    label: l.name,
  }));

  const onClick: MenuProps['onClick'] = (info) => {
    setSelectedLocationId(Number(info.key));
  };

  return (
    <Dropdown
      menu={{ items, onClick, selectedKeys: [String(selectedLocationId ?? '')] }}
      trigger={['click']}
    >
      <Tag
        style={{
          backgroundColor: '#ffffff',
          cursor: 'pointer',
          color: '#3b3b3b',
          borderColor: '#ffffff',
          paddingBlock: 4.8,
          paddingInline: 9.6,
          fontSize: 16,
          display: 'flex',
          alignItems: 'center',
          columnGap: 5,
          height: 38,
          marginInlineEnd: 0,
        }}
      >
        <span dir="auto">{label}</span>
        <FontAwesomeIcon icon={faAngleDown} style={{ color: '#3B3B3B' }} />
      </Tag>
    </Dropdown>
  );
}
